import type { GetOrganizationDetailTabPathParams } from '../types';

const getOrganizationDetailTabPath = ({
    organizationId,
    tab,
    search,
}: GetOrganizationDetailTabPathParams): string => {
    const pathname = `/admin/organizations/${organizationId}/${tab}`;
    return `${pathname}${search}`;
};

export default getOrganizationDetailTabPath;
